export const Predicates = {
  IsAuthenticated: 'Predicates/IsAuthenticated',
  GroupAdminRolesResolved: 'Predicates/GroupAdminRolesResolved',
  GroupFeatureMapInitialized: 'Predicates/GroupFeatureMapInitialized',
  GroupRevenueAccessResolved: 'Predicates/GroupRevenueAccessResolved',
  GroupSelected: 'Predicates/GroupSelected',
  LicenseAgreementInitialized: 'Predicates/LicenseAgreementInitialized',
  LmsEnabled: 'Predicates/LmsEnabled',
  OrgAvailablePricebooksInitialized: 'Predicates/OrgAvailablePricebooksInitialized',
  OrgAdminRolesResolved: 'Predicates/OrgAdminRolesResolved',
  OrganizationSelected: 'Predicates/OrganizationSelected',
  PricebooksSelected: 'Predicates/PricebooksSelected',
  RevenueAccessResolved: 'Predicates/RevenueAccessResolved',
  SubscriptionInitialized: 'Predicates/SubscriptionInitialized',
  TeamAdminRolesResolved: 'Predicates/TeamAdminRolesResolved',
  TeamAvailablePricebooksInitialized: 'Predicates/TeamAvailablePricebooksInitialized',
  TeamRevenueAccessResolved: 'Predicates/TeamRevenueAccessResolved',
  TeamSelected: 'Predicates/TeamSelected',
  UserInitialized: 'Predicates/UserInitialized',
  UserRolesInitialized: 'Predicates/UserRolesInitialized',
};
